module.exports = __webpack_public_path__ + "img/6.11b997e6.jpg";